import { render, staticRenderFns } from "./PwdDef.vue?vue&type=template&id=aaf676aa&scoped=true"
import script from "./PwdDef.vue?vue&type=script&lang=ts"
export * from "./PwdDef.vue?vue&type=script&lang=ts"
import style0 from "./PwdDef.vue?vue&type=style&index=0&id=aaf676aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf676aa",
  null
  
)

export default component.exports